// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"256dbeb0","856":"5392b44a","952":"1d6ceb93"}[chunkId] + ".chunk.js";
};